(function () {
  if (window.__ivBackBtn) return;
  window.__ivBackBtn = true;

  var st = document.createElement("style");
  st.textContent =
    ".iv-back-btn{position:absolute;top:14px;left:14px;z-index:50;display:inline-flex;align-items:center;gap:7px;" +
    "padding:9px 16px 9px 12px;background:rgba(10,10,11,.82);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);" +
    "color:#ECEAE5;border:1px solid rgba(236,234,229,.22);border-radius:999px;" +
    "font-family:'Helvetica Neue',Arial,sans-serif;font-size:12px;font-weight:700;letter-spacing:.12em;line-height:1;" +
    "text-transform:uppercase;text-decoration:none;cursor:pointer;transition:background-color .18s,border-color .18s,transform .08s}" +
    ".iv-back-btn:hover{background:#D7263D;border-color:#D7263D;color:#fff}" +
    ".iv-back-btn:active{transform:translateY(1px)}" +
    ".iv-back-btn svg{width:15px;height:15px;display:block}" +
    "@media(max-width:749px){.iv-back-btn{top:10px;left:10px;padding:7px 13px 7px 10px;font-size:11px}}";
  document.head.appendChild(st);

  function add() {
    if (!document.body.classList.contains("template-product-invictus")) return;
    if (document.querySelector(".iv-back-btn")) return;
    var host = document.querySelector(".iv-product__gallery") ||
               document.querySelector(".iv-product__media") ||
               document.querySelector("section.invictus-product .iv-product__col--media");
    if (!host) return;
    if (getComputedStyle(host).position === "static") host.style.position = "relative";
    var a = document.createElement("a");
    a.className = "iv-back-btn";
    a.href = "/pages/invictus-shop-all";
    a.setAttribute("aria-label", "返回商品列表");
    a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg><span>返回</span>';
    host.insertBefore(a, host.firstChild);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", add);
  else add();
  setTimeout(add, 500);
  setTimeout(add, 1500);
})();
